<script lang="typescript">
    import ButtonText from "./typography/button.svelte";

    export let type: "text" | "rised" = "text";
    export let text = "button";
    export let disabled = false;
</script>

<button class="btn type-{type}" on:click {disabled}>
    <ButtonText
        {text}
        color={type === "rised" ? "white" : "var(--color-primary)"}
    />
</button>

<style>
    .btn {
        height: 36px;
        min-width: 83px;
        outline: none;
        border: none;
        padding: 0 16px;
        display: flex;
        flex-shrink: 0;
        align-items: center;
    }
    .btn[disabled] {
        opacity: 0.3;
    }

    .type-text {
        background: transparent;
    }
    .type-text:hover {
        background: rgba(var(--color-primary-value), 0.1);
    }
    .type-text:active {
        background: rgba(var(--color-primary-value), 0.3);
    }

    .type-rised {
        background: rgba(var(--color-primary-value), 0.9);
    }
    .type-rised:hover {
        background: rgba(var(--color-primary-value), 1);
    }
</style>
